<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { Locales } from '@/store/language.interface';
import { getLabel } from '@/utils/data-display-utils';

// CONST
const initialLocales = ref([]);
const locales = ref([]);
const props = defineProps<{
  modelValue: Locales;
  languageEnabled?: Locales[];
}>();
const emit = defineEmits<{
  (e: 'update:modelValue', locale: Locales): void;
}>();

// LIFECYCLE
onMounted(() => {
  initialLocales.value = props.languageEnabled;
  initialLocales.value.forEach((locale) => locales.value.push(locale));
});
</script>

<template>
  <div class="locale-select">
    <span id="locale-select-label" class="locale-select__sr-label">
      {{ getLabel('aria-label.header.select-language', props.languageEnabled) }}
    </span>
    <q-select
      label-color="primary"
      color="primary"
      borderless
      :model-value="props.modelValue"
      :options="locales"
      aria-labelledby="locale-select-label"
      @update:model-value="emit('update:modelValue', $event)"
    >
      <template v-slot:prepend>
        <q-icon name="o_language" />
      </template>
      <template v-slot:option="scope">
        <q-item v-bind="scope.itemProps">
          <q-item-section>
            <q-item-label>{{ scope.opt.toUpperCase() }}</q-item-label>
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<style lang="scss">
.locale-select {
  position: relative;

  &__sr-label {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  .q-select {
    text-transform: uppercase;
  }

  .q-field--auto-height .q-field__control {
    min-height: 40px !important;
    height: 40px !important;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
  }

  .q-field--focused .q-field__control,
  .q-field:focus-within .q-field__control {
    outline: 2px solid $color-primary;
    outline-offset: 2px;
    border-radius: 4px;
  }

  .q-field__prepend {
    padding-right: 6px;
  }

  .q-field__append {
    padding-left: 6px;
  }
}
</style>
